import { render, staticRenderFns } from "./MedInfo.vue?vue&type=template&id=53c758b0&scoped=true"
import script from "./MedInfo.vue?vue&type=script&lang=js"
export * from "./MedInfo.vue?vue&type=script&lang=js"
import style0 from "./MedInfo.vue?vue&type=style&index=0&id=53c758b0&prod&lang=scss&scoped=true"
import style1 from "./MedInfo.vue?vue&type=style&index=1&id=53c758b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c758b0",
  null
  
)

export default component.exports